import './select2.scss';
import './select2';
import './select2_locale_ru';